import React, { useEffect } from "react";
import { connect } from "react-redux";
import OfflinePage from "../OfflinePage/OfflinePage";
import { ROLES } from "../../constants";
import ScanContainerDispatch from "../../components/PackSlip/ScanContainerDispatch";
import UserGreeting from "../../components/UserGreeting/UserGreeting";

const PrintPackSlip = (props) => {
  useEffect(() => {
    if (
      props.userRole?.filter(
        (k) =>
          k?.roleName === ROLES.TO_PACKER_ROLE ||
          k?.roleName === ROLES.TO_DISPATCH_ROLE
      )?.length === 0
    ) {
      props.history.push("/Profile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!props.isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <UserGreeting />
      <ScanContainerDispatch />
    </>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.authReducer?.AuthData?.userDTO.role,
  isOnline: state.statusReducer?.isOnline,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PrintPackSlip);
